var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStarSolid = function SvgStarSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: 0,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8 13.346 3.998 2.526c.63.398 1.409-.194 1.242-.944l-1.062-4.76 3.533-3.204c.557-.505.26-1.462-.474-1.527l-4.651-.413L8.766.531a.819.819 0 0 0-1.533 0L5.414 5.024l-4.65.413C.03 5.502-.269 6.459.288 6.964l3.533 3.203-1.062 4.761c-.167.75.611 1.342 1.242.944z"
  })));
};
export default SvgStarSolid;